import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/components/seo/PageStructuredData.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/src/providers/I18nProvider.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/src/styles/tailwind.css");
